var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.75C12.5188 13.75 13.75 12.5188 13.75 11C13.75 9.48122 12.5188 8.25 11 8.25C9.48122 8.25 8.25 9.48122 8.25 11C8.25 12.5188 9.48122 13.75 11 13.75Z",
    fill: "#6AA287"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.3335 3.66683H15.4277L14.291 2.42933C14.1202 2.24177 13.9121 2.09191 13.6801 1.98932C13.4481 1.88672 13.1972 1.83365 12.9435 1.8335H9.05683C8.5435 1.8335 8.0485 2.0535 7.70016 2.42933L6.57266 3.66683H3.66683C2.6585 3.66683 1.8335 4.49183 1.8335 5.50016V16.5002C1.8335 17.5085 2.6585 18.3335 3.66683 18.3335H18.3335C19.3418 18.3335 20.1668 17.5085 20.1668 16.5002V5.50016C20.1668 4.49183 19.3418 3.66683 18.3335 3.66683ZM11.0002 15.5835C8.47016 15.5835 6.41683 13.5302 6.41683 11.0002C6.41683 8.47016 8.47016 6.41683 11.0002 6.41683C13.5302 6.41683 15.5835 8.47016 15.5835 11.0002C15.5835 13.5302 13.5302 15.5835 11.0002 15.5835Z",
    fill: "#6AA287"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bd7a18cd5c31d72bc3f0d9c8fe4a28ae.svg";
export { ForwardRef as ReactComponent };